import { useMutation } from '@apollo/client';
import { gql } from 'graphql-tag';

// Define the mutation
const UPDATE_RECIPE_COUNTER = gql`
  mutation UpdateRecipeCounter($recipe_id: ID!, $task: String!) {
    updateRecipeCounter(recipe_id: $recipe_id, task: $task) {
      success
      message
    }
  }
`;

// Custom hook to update the recipe counter
export const useUpdateRecipeCounter = () => {
  const [updateRecipeCounter, { data, loading, error }] = useMutation(UPDATE_RECIPE_COUNTER);

  // Function to trigger the mutation
  const incrementRecipeCounter = async (recipe_id, task) => {
    try {
      const response = await updateRecipeCounter({ variables: { recipe_id, task } });
      return response.data.updateRecipeCounter;
    } catch (err) {
      console.error("Failed to update recipe counter:", err);
      throw err;
    }
  };

  return { incrementRecipeCounter, data, loading, error };
};
